import {TableProps} from "antd";
import React from "react";
import {BasicTable} from "../../Common/BasicComponents/BasicTable";
import {AdminHttpService} from "../../../services/Http/SearchTableService";
import {FilterSelect} from "../../Common/BasicComponents/filters/FilterSelect";
import {Procedure} from "../../../models/Procedure";
import {PageTitle} from "../../Common/PageTitle/PageTitle";

export interface ProcedureContractPageProps {

}

export type AnyObject = Record<string, any>;

export function ProcedurePage<T extends AnyObject>(props:ProcedureContractPageProps) {

    const contractColumns: TableProps<Procedure>['columns'] = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Codice',
            dataIndex: 'code',
            key: 'code'
        },
        {
            title: 'Descrizione',
            dataIndex: 'description',
            key: 'description'
        }
        // ,{
        //     title: 'Contratto Secondario',
        //     dataIndex: 'secondaryContract',
        //     key: 'secondaryContract'
        // }
    ]

    const searchFilters =[
        <FilterSelect dataKey={"primaryContractId"} placeholder={"Contratto Principale"}
                      api={{
                          url: AdminHttpService.URL_ADMIN_CONTRACTS,
                          value: "id",
                          label: "code",
                          sendAsObject: false
                      }} showSearch={true}></FilterSelect>,
    ]


    return <>
        <PageTitle title={"Gestione procedure"}></PageTitle>
        <BasicTable<Procedure>
            columns={contractColumns}
            urlPath={AdminHttpService.URL_ADMIN_PROCEDURES}
            filters={searchFilters}
        />
    </>

}